export default {
  baseURL: 'https://dev-now-api.funda.kr/api',
  adminURL: 'https://dev-now-api.funda.kr/_admin'
}
